import * as React from "react"
import { graphql, Link } from "gatsby"
import { Layout } from "../components/layout"
import { Swiper, SwiperSlide } from 'swiper/react';
import { GatsbyImage, getSrc, StaticImage } from "gatsby-plugin-image"
import { Footer } from "../components/footer";

import image1 from "../images/litebar.jpg"
import image2 from "../images/lb-2.jpg"
import image3 from "../images/lb-3.jpeg"

import SwiperCore, {
  EffectFade, Autoplay
} from "swiper";
import 'swiper/css';

import 'swiper/css/effect-fade';

import { ProductListing } from "../components/product-listing"

import "./index.module.css"

import {
  container,
  intro,
  callOut,
  callToAction,
  deployButton,
} from "./index.module.css"
SwiperCore.use([Autoplay, EffectFade]);

const ProductDisplay = () => {
  return (
    <div className="flex flex-col md:flex-row">
    <div className="basis-2/3 shadow-md bg-black">
      <div className="object-fill w-full max-h-full shadow-inner">
        <img
          src={image1}
          className="spotlight-container"
        />
      </div>
    </div>
    <div className=" bg-gray-100 shadow-md basis-1/3 " >
      <div className="m-5">
        <p className="text-2xl font-bold now-alt">Look Great Online</p>
        <p className="mt-5 ">CameraReady Lighting was founded by Christien Methot, EMMY® Nominated Lighting Designer. During the
          tough times we are currently in due to COVID-19, Methot found himself in video meetings with poorly-lit

          clients. He created CameraReady to solve that problem.</p>
      </div>
    </div>

  </div>
  )
}







const Hero = ({ data }) => {
  return (
    <Swiper
      slidesPerView={'auto'}
      loop={true}
      preventClicks={true}
      className="swiper-wrap object-container mx-auto"
    >
      {data.allGraphCmsHomePageImage.edges.map((image, index) => (

        <SwiperSlide className="border-b-2 border-black">
          <h1 className="absolute z-10 h-1/2 text-black bg-white w-3/4  bottom-0 p-3 text-md md:text-4xl  md:w-1/4"> {image.node.description} <br/>
           <Link className="uppercase text-sm underline" to={image.node.link}>{image.node.buttonText}</Link></h1>
          <div className="swiper-wrap-child h-full w-full">
            <GatsbyImage
              loading={index === 0 ? "eager" : "lazy"}
              image={image.node.image.gatsbyImageData}
              className="h-full w-full object-fill shadow-inner"
            />
          </div>
        </SwiperSlide>

      ))}

    </Swiper>
  )
}

export default function IndexPage({ data }) {
  return (
    <Layout>
      <Hero data={data} />


      <div className="">

        </div>

      {/* <div className="h-52">
        <div className="grid grid-cols-2">
          <div className="">
            
          </div>
          <div className="mt-5">
            <h1 className="text-5xl">Designed by an industry professional</h1>
            <p className="text-3xl mt-5 w-3/4">CameraReady Lighting was founded by Christien
Methot, EMMY® Nominated Lighting Designer. During
the tough times we are currently in due to COVID-19,
Methot found himself in video meetings with poorly-lit
clients. He created CameraReady to solve that problem.</p>
          </div>
        </div>
      </div> */}
    </Layout>
  )
}



export const query = graphql`
  query {
    shopifyCollection(handle: { eq: "frontpage" }) {
      products {
        ...ProductCard
      }
    }
    allGraphCmsHomePageImage {
      edges {
        node {
          image {
            gatsbyImageData
          }
          link
          description
          buttonText
        }
      }
    }
  }
`